export const storeInData = (key, value) => {
    if (!key) {
        console.log("No key received!! :: (Cookies Utils)");
        return;
    }
    if (!value) {
        console.log("Empty value is setting in cookies!! :: (Cookies Utils)");
        return;
    }
    localStorage.setItem(key, value);
};

export const getDataFromStore = (key) => {
    if (!key) {
        console.log("No key received!! :: (Cookies Utils)");
        return;
    }
    const value = localStorage.getItem(key);
    return value;
};

export const removeDataFromStore = (key) => {
    if (!key) {
        console.log("No key received!! :: (Cookies Utils)");
        return;
    }
    localStorage.removeItem(key);
};
